import { findAppOptionLabel } from './dataListHelpers'

export function buildCountryFilterReadonly(country) {
  if (!country || !Array.isArray(country.countries) || !country.countries.length) {
    return '未配置'
  }
  const mode = country.isExclude ? '不包含' : '包含'
  return `${mode}：${country.countries.join(', ')}`
}

export function buildVersionFilterReadonly(version) {
  const start = version && version.start !== '' && version.start != null ? version.start : null
  const end = version && version.end !== '' && version.end != null ? version.end : null
  const skip = version && String(version.skip || '').trim()

  if (start == null && end == null && !skip) {
    return '未配置'
  }

  const parts = []
  if (start != null || end != null) {
    parts.push(`${start ?? '—'}–${end ?? '—'}`)
  }
  if (skip) {
    parts.push(`跳过 ${skip}`)
  }
  return parts.join(' · ')
}

export function resolvePageName(pageOptions, pageId) {
  const id = Number(pageId)
  const matched = (pageOptions || []).find((item) => Number(item.id) === id)
  return matched && matched.name ? matched.name : '—'
}

export function resolveAppLabel(appOptions, appId) {
  return findAppOptionLabel(appOptions, appId)
}
